import React from "react";
import { Input } from "@revvsales/components";
import { RevvForm, ErrorMessages } from "../../../../commonComponents";

import {
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../../DynamicField/DynamicFieldComponents/CustomFieldRulesMap";

import { DOCUMENTS } from "../../../../constants";

const { FORM_FIELDS_DEFAULT_VALUES } = DOCUMENTS;

export default class AddressFormMode extends React.Component {
  state = {
    // eslint-disable-next-line no-nested-ternary
    personNameTextFieldValues: this.props.initialProps.value
      ? JSON.parse(JSON.stringify(this.props.initialProps.value))
      : this.props.initialProps.meta && this.props.initialProps.meta.default
      ? JSON.parse(JSON.stringify(this.props.initialProps.meta.default))
      : JSON.parse(JSON.stringify(FORM_FIELDS_DEFAULT_VALUES.ADDRESS)),
  };

  _handleOnBlur = (
    event,
    value,
    defaultValues,
    handleBlur,
    isValidated,
    type,
  ) => {
    handleBlur(event);
    // If the field is validated & there is a value then only
    // make an API call and update the redux store
    const { id } = this.props.initialProps;
    const combinedValue = this._getAddressCombinedValue(id, defaultValues);
    if (type === "ADDRESS_LINE_TWO" || type === "COUNTRY") {
      if (!combinedValue.split(" ").includes("")) {
        this._checkForUpdateField(defaultValues, type);
      }
    } else if (isValidated && value) {
      if (!combinedValue.split(" ").includes("")) {
        this._checkForUpdateField(defaultValues, type);
      }
    }
  };

  _getAddressCombinedValue = (id, values) => {
    let combinedValue = "";
    const {
      addressLineOne,
      addressLineTwo,
      city,
      state,
      zip,
      country,
    } = values;

    combinedValue = `${addressLineOne}, ${addressLineTwo}, ${city}, ${state} - ${zip} ${
      country.length !== 0 ? `(${country})` : ""
    }`;
    this.props._updateDynamicFieldsInDoc(id, values);
    // Checking All the required fields are filled or not
    if (addressLineOne && city && state && zip) {
      this._updateFilledStatus(true);
    } else this._updateFilledStatus(false);
    return combinedValue;
  };

  _updateFilledStatus = status => {
    this.props.filledStatus(status);
  };

  _checkForUpdateField = (currentValue, type) => {
    const { id } = this.props.initialProps;
    const { addressLineOne, addressLineTwo, city, state, country, zip } =
      this.props.initialProps.value || {};

    if (type === "ADDRESS_LINE_ONE" && addressLineOne !== currentValue) {
      this.props._updateField(id, currentValue, "addressLineOne");
    } else if (type === "ADDRESS_LINE_TWO" && addressLineTwo !== currentValue) {
      this.props._updateField(id, currentValue, "addressLineTwo");
    } else if (type === "CITY" && city !== currentValue) {
      this.props._updateField(id, currentValue, "city");
    } else if (type === "STATE" && state !== currentValue) {
      this.props._updateField(id, currentValue, "state");
    } else if (type === "COUNTRY" && country !== currentValue) {
      this.props._updateField(id, currentValue, "country");
    } else if (type === "ZIP" && zip !== currentValue) {
      this.props._updateField(id, currentValue, "zip");
    }
  };

  render() {
    const { id /* docIsLocked */ } = this.props.initialProps;
    return (
      <React.Fragment>
        <RevvForm
          revvFormId={id}
          initialFormValue={this.state.personNameTextFieldValues}
          customFieldName="ADDRESS"
          customFieldComponentRules={CustomFieldComponentRules}
          validateOnChange
          customFieldComponentMessages={CustomFieldComponentMessages}
          render={formProps => {
            const { handleChange, handleBlur, messages, values } = formProps;
            return (
              <React.Fragment>
                <div>
                  <div className="composite-field-address">
                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="addressLineOne"
                        className="form-mode-input"
                        // {`form-mode-input ${
                        //   messages.addressLineOne &&
                        //   messages.addressLineOne.required !== ""
                        //     ? "danger-border"
                        //     : ""
                        // }`}
                        placeholder="Enter Address Line 1"
                        value={values && values.addressLineOne}
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlur(
                            event,
                            values.addressLineOne,
                            values,
                            handleBlur,
                            !messages.addressLineOne,
                            "ADDRESS_LINE_ONE",
                          )
                        }
                        disabled={this.props.isLocked}
                        autoFocus
                        data-test="address-form-mode-addressLineOne"
                      />
                      {/* <div>
                        {messages.addressLineOne && (
                          <ErrorMessages
                            messages={messages.addressLineOne.required}
                          />
                        )}
                      </div> */}
                    </div>
                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="addressLineTwo"
                        className="form-mode-input"
                        placeholder="Enter Address Line 2 (Optional)"
                        value={values && values.addressLineTwo}
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlur(
                            event,
                            values.addressLineTwo,
                            values,
                            handleBlur,
                            !messages.addressLineTwo,
                            "ADDRESS_LINE_TWO",
                          )
                        }
                        disabled={this.props.isLocked}
                        data-test="address-form-mode-addressLineTwo"
                      />
                    </div>
                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="city"
                        className={`form-mode-input ${
                          messages.city && messages.city.required !== ""
                            ? "danger-border"
                            : ""
                        }`}
                        placeholder="Enter City"
                        value={values && values.city}
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlur(
                            event,
                            values.city,
                            values,
                            handleBlur,
                            !messages.city,
                            "CITY",
                          )
                        }
                        disabled={this.props.isLocked}
                        data-test="address-form-mode-city"
                      />
                      <div>
                        {messages.city && (
                          <ErrorMessages messages={messages.city.required} />
                        )}
                      </div>
                    </div>
                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="state"
                        className={`form-mode-input ${
                          messages.state && messages.state.required !== ""
                            ? "danger-border"
                            : ""
                        }`}
                        placeholder="Enter State"
                        value={values && values.state}
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlur(
                            event,
                            values.state,
                            values,
                            handleBlur,
                            !messages.state,
                            "STATE",
                          )
                        }
                        disabled={this.props.isLocked}
                        data-test="address-form-mode-state"
                      />
                      <div>
                        {messages.state && (
                          <ErrorMessages messages={messages.state.required} />
                        )}
                      </div>
                    </div>
                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="zip"
                        className={`form-mode-input ${
                          messages.zip && messages.zip.required !== ""
                            ? "danger-border"
                            : ""
                        }`}
                        placeholder="Enter ZIP"
                        type="number"
                        value={values && values.zip}
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlur(
                            event,
                            values.zip,
                            values,
                            handleBlur,
                            !messages.zip,
                            "ZIP",
                          )
                        }
                        disabled={this.props.isLocked}
                        data-test="address-form-mode-zip"
                      />
                      <div>
                        {messages.zip && (
                          <ErrorMessages messages={messages.zip.required} />
                        )}
                      </div>
                    </div>
                    <div className="composite-field-address-full-span">
                      <Input
                        id={id}
                        name="country"
                        className="form-mode-input"
                        placeholder="Enter Country (Optional)"
                        value={values && values.country}
                        onChange={event => handleChange(event)}
                        onBlur={event =>
                          this._handleOnBlur(
                            event,
                            values.country,
                            values,
                            handleBlur,
                            !messages.country,
                            "COUNTRY",
                          )
                        }
                        disabled={this.props.isLocked}
                        data-test="address-form-mode-country"
                      />
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentV2/FormView/FormModeComponents/AddressFormMode.js